import WeekDay from './week-day';

export default WeekDay;
